import { Link } from "react-router-dom";

const CHANNEL_LINKS = [
  { to: "/dispatch/breaking", label: "突发专报" },
  { to: "/dispatch/flash", label: "紧急插播" },
  { to: "/dispatch/headline", label: "头条专递" },
  { to: "/dispatch/deep", label: "深度瓜情" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-black">
                瓜
              </span>
              <span className="font-heading text-xl font-black text-background-50">瓜田速递</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 max-w-md">
              突发专报与紧急插播同步刷新，重大瓜情一手直达。我们只做一件事：把正在发生的事，
              在最短时间内讲清楚，并把脉络一并交给你。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs font-label text-background-200/70">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-gt-pulse-dot"></span>
              编辑部实时值守中
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#guatian-footer" className="hover:text-accent-400 transition-colors">
                内容频道
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {CHANNEL_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/75 hover:text-background-50 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#guatian-footer" className="hover:text-accent-400 transition-colors">
                关于本站
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-200/75 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#principle" className="text-sm text-background-200/75 hover:text-background-50 transition-colors">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-200/75 hover:text-background-50 transition-colors">
                  联系与爆料
                </Link>
              </li>
              <li>
                <a href="#subscribe" className="text-sm text-background-200/75 hover:text-background-50 transition-colors">
                  订阅简报
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#guatian-footer" className="hover:text-accent-400 transition-colors">
                联系方式
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/75">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span className="break-all">tips@guatian-express.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>每日 07:00 – 次日 01:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © {new Date().getFullYear()} 瓜田速递 · 本站内容仅为资讯聚合与脉络梳理，不构成对任何个人的定性评价。
          </p>
          <p className="text-xs text-background-200/60">
            如有内容异议，欢迎通过邮箱联系我们处理。
          </p>
        </div>
      </div>
    </footer>
  );
}